<div class="home-item-selector__content-headers">
  <div class="home-item-selector__categories">
    <span>Type</span>
  </div>
  <div class="home-item-selector__items">
    <span>Name</span>
  </div>
  <div class="home-item-selector__description">
    <span>Preview</span>
  </div>
</div>
<div class="home-item-selector__content">
  <div class="home-item-selector__categories">
    <ul class="home-item-selector__category-list">
      <ng-container *ngFor="let category of categories">
        <li *ngIf="category.subCategories.length"
            [class.selected]="category === selectedCategory">
          <div class="home-item-selector__category-list-header">
            <i class="fas" [class]="category.icon"></i><span>{{category.name}}</span>
          </div>
          <ul class="home-item-selector__item-list">
            <li *ngFor="let subCategory of category.subCategories" class="pl-10"
                [class.selected]="subCategory === selectedSubCategory"
                (click)="selectSubCategory(subCategory)">
              {{subCategory.name}} ({{subCategory.items.length}})
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
  <div class="home-item-selector__items">
    <ng-container *ngIf="selectedSubCategory?.items?.length">
      <div class="home-item-selector__category-list-header h-30">
        <i class="fas" [class]="selectedSubCategory.icon"></i>
        <span>{{selectedSubCategory.name}} ({{selectedSubCategory.items.length}})</span>
      </div>
      <ul class="home-item-selector__item-list">
        <li *ngFor="let item of selectedSubCategory.items"
            [class.selected]="selectedItem === item"
            (mouseover)="selectItem(item)"
            (click)="setCurrentItem()"
            class="text-ellipsis pr-8 pointer">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </ng-container>
  </div>
  <div *ngIf="selectedItem"
       class="home-item-selector__preview pr-15 pl-15 d-flex flex-dir-column">
    <div class="home-item-selector__preview-header h-30 d-flex align-items-center">
      <span>{{selectedItem.name}}</span>
    </div>
    <div class="d-flex pt-10 home-item-selector__preview-content">
      <ng-container *ngIf="selectedItem.dashboardPreview">
        <app-dashboard-preview class="w-100p"
                               [dashboard]="selectedItem.dashboardPreview"
                               [displayNames]="true"
                               iconSize="36px"
                               smallIconSize="30px"></app-dashboard-preview>
      </ng-container>

      <ng-container *ngIf="selectedItem.visualPreviewUrl">
        <div class="home-item-selector__preview-visual-wrapper">
          <div class="home-item-selector__preview-visual-icon" style="background-image: url('{{selectedItem.visualPreviewUrl}}'); "></div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
